import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { RevealLineOnView } from "./RevealLine";
import { SERVICES as T } from "@/constants/testIds";

const IMAGES = {
  "full-detail-small":
    "https://images.pexels.com/photos/11139244/pexels-photo-11139244.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1400",
  "full-detail-medium":
    "https://images.unsplash.com/photo-1723844733211-203389c911c2?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  "full-detail-large":
    "https://images.unsplash.com/photo-1633348570573-2c70fe9129de?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  "ceramic-coating":
    "https://images.pexels.com/photos/10463764/pexels-photo-10463764.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1400",
};

export default function Services({ services, onBook }) {
  return (
    <section id="services" data-testid={T.root} className="py-28 md:py-40 bg-[#0a0a0a]">
      <div className="max-w-[1600px] mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 mb-16 md:mb-24">
          <p className="md:col-span-5 eyebrow">
            <RevealLineOnView>The Menu — Services</RevealLineOnView>
          </p>
          <h2 className="md:col-span-7 font-serif text-5xl md:text-7xl font-light tracking-tight text-white leading-[0.95]">
            <RevealLineOnView>Pricing</RevealLineOnView>
            <RevealLineOnView delay={0.06} className="italic text-neutral-400">
              starting at $280.
            </RevealLineOnView>
          </h2>
        </div>

        <div className="border-t border-white/10">
          {services.map((s, i) => (
            <motion.article
              key={s.id}
              data-testid={T.card(s.id)}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.8, delay: i * 0.05, ease: [0.22, 1, 0.36, 1] }}
              className="group grid grid-cols-12 gap-4 md:gap-8 py-8 md:py-10 border-b border-white/10 items-center relative overflow-hidden"
            >
              {/* Row image reveal */}
              <div className="pointer-events-none absolute right-0 top-1/2 -translate-y-1/2 w-[38%] aspect-[4/3] opacity-0 group-hover:opacity-100 transition-opacity duration-500 hidden lg:block">
                <img
                  src={IMAGES[s.id]}
                  alt=""
                  className="w-full h-full object-cover"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-l from-transparent via-[#0a0a0a]/40 to-[#0a0a0a]" />
              </div>

              <div className="col-span-2 md:col-span-1 font-mono text-xs md:text-sm text-neutral-500">
                0{i + 1}
              </div>
              <div className="col-span-10 md:col-span-5">
                <h3 className="font-serif text-3xl md:text-5xl font-light text-white leading-tight">
                  {s.name}
                </h3>
                <p className="mt-2 font-mono text-[11px] tracking-[0.24em] uppercase text-neutral-500">
                  {s.subtitle}
                </p>
              </div>
              <div className="col-start-3 md:col-start-7 col-span-6 md:col-span-3 text-neutral-400 text-sm md:text-base">
                <ul className="space-y-1">
                  {s.includes.slice(0, 4).map((line) => (
                    <li key={line} className="flex gap-2">
                      <span className="text-neutral-600">—</span>
                      <span>{line}</span>
                    </li>
                  ))}
                  {s.includes.length > 4 && (
                    <li className="text-neutral-600 text-xs">
                      +{s.includes.length - 4} more inclusions
                    </li>
                  )}
                </ul>
              </div>
              <div className="col-span-6 md:col-span-2 text-right md:text-left">
                <div className="font-serif text-4xl md:text-6xl text-white">
                  ${s.price}
                </div>
                <div className="font-mono text-[10px] tracking-[0.24em] uppercase text-neutral-500">
                  {s.currency}
                </div>
              </div>
              <div className="col-span-6 md:col-span-1 flex justify-end">
                <button
                  onClick={() => onBook?.(s.id)}
                  data-testid={T.cardBook(s.id)}
                  className="w-11 h-11 rounded-full border border-white/20 flex items-center justify-center text-white transition-all duration-300 hover:bg-white hover:text-black hover:scale-110"
                  aria-label={`Book ${s.name}`}
                >
                  <ArrowUpRight size={16} />
                </button>
              </div>
            </motion.article>
          ))}
        </div>

        <p className="mt-10 font-mono text-[11px] tracking-[0.24em] uppercase text-neutral-500">
          + Engine bay clean available on any full detail · $100
        </p>
      </div>
    </section>
  );
}
